import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Button, ButtonToolbar, Col, Input, Popover, Row, Modal, Overlay} from 'react-bootstrap'
import cx from 'classnames'
import {buttonField, connectForm} from '../../core/redux/form'
import {errorStatus} from '../../core/redux/status'
import extract from '../../core/extract'
import {phonesField} from '../../core/phonez'
import {linkFinder} from '../../core/links'
import {addressField, autocompleteMatcher, displayPrediction, highlightPrediction} from '../../core/google/places'
import Icon from '../../core/components/Icon'
import LoaderButton from '../../core/components/LoaderButton'
import ButtonToggle from '../../core/components/ButtonToggle'
import MultiInput from '../../core/components/MultiInput'
import TypeaheadInput from '../../core/components/TypeaheadInput'
import {
    loadContactStream,
    loadLot,
    loadPatrimony,
    REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED,
    sendReferencePatrimonyContactCmd,
    updateReferencePatrimonyContactCmd,
    sendLinkPatrimonyContactWithUser,
    sendReferenceUserCmd,
    sendShouldCreateUser,
    resetReferenceUserCmd,
} from '../actions'

import {
    CONTACT_LOT_LINK_TYPES,
    CONTACT_PATRIMONY_LINK_TYPES,
    createValidator,
    HOME_OWNER_ASSOCIATION_POSITIONS,
    NON_REFERENCED_LOT_POSITIONS,
    ReferencePatrimonyContactCmd,
} from '../models'
import i18n from '../i18n'
import style from './ReferencePatrimonyContactPopover.less'
import {findDOMNode} from 'react/lib/ReactDOM'

function restrict(allowed, value) {
    if (value) return allowed.indexOf(value) >= 0 && value || allowed[0]
    return allowed[0]
}

function mediumReducer(type) {
    return (result, medium) => {
        var filtered = result[0] || (result[0] = [])
        var filteredOut = result[1] || (result[1] = [])

        if (medium.contactInfoType == type) {
            filtered.push(medium)
        } else {
            filteredOut.push(medium)
        }

        return result
    }
}

const mediumField = (field, type) => {
    const arrayValue = field.value || []
    const [mediumsValue, otherMediumsValue] = arrayValue.reduce(mediumReducer(type), [[], []])

    const value = mediumsValue.map((medium) => {
        switch(type) {
            case 'Phone': return medium.phone
            case 'Mail': return medium.mail
            case 'Fax': return medium.fax
        }
    })

    function onChange(value) {
        const nextMediumsValue = value.map((value) => {
            switch(type) {
                case 'Phone': return {phone: value, contactInfoType: 'Phone'}
                case 'Mail': return {mail: value, contactInfoType: 'Mail'}
                case 'Fax': return {fax: value || null, contactInfoType: 'Fax'}
            }
        })

        const nextValue = [...otherMediumsValue, ...nextMediumsValue]
        field.onChange(nextValue)
    }

    return {...field, value, onChange}
}

const linkTypeField = (field) => {
    function onChange(value) {
        if (value) {
            field.onChange(value)
        }
    }

    return {...field, onChange}
}


const linkedWithField = (lot, field) => {
    const value = field.value && field.value.position

    function onChange(event) {
        const value = event.target.value

        const nextLinkedWithValue = value && {linkType: 'LinkToPatrimonyAsHomeOwnerAssociation', position: value, patrimonyUid: lot.patrimony.uid}
        field.onChange(nextLinkedWithValue)
    }

    return {...field, value, onChange}
}

const requiredLabel = (label) => (
    <span>{label} <i>*</i></span>
)

const addressTypeaheadButton = (cmd, form) => {
    if (cmd && cmd.address) {
        return (
            <Button
                {...buttonField(form.address(), null)}>
                <Icon icon='minus' size='xs' />
            </Button>
        )
    }
    return (
        <Button>
            <Icon icon='plus' size='xs' />
        </Button>
    )
}

class ReferencePatrimonyContactPopover extends Component {
    static propTypes = {
        patrimony: PropTypes.object,
        lot: PropTypes.object,
        onHide: PropTypes.func.isRequired,
        popoverToOpen: PropTypes.string.isRequired
    }

    constructor(props) {
        super(props)
    }

    componentStart = (props, shouldDispatch = true) => {
        const {dispatch, cmd, patrimony, lot} = props
        const linkTypes = (patrimony && CONTACT_PATRIMONY_LINK_TYPES) || (lot && CONTACT_LOT_LINK_TYPES)
        const linkType = restrict(linkTypes, cmd && cmd.linkedWithEntities && cmd.linkedWithEntities.linkType)

        this.setState({linkTypes})

        if (shouldDispatch) {
            dispatch(updateReferencePatrimonyContactCmd({
                linkedWithEntities: {
                    ...(cmd && cmd.linkedWithEntities),
                    lotUid: lot && lot.uid,
                    patrimonyUid: patrimony && patrimony.uid,
                    linkType: linkType,
                },
                linkedWithPatrimonyAsHomeOwnerAssociation: {
                    ...(cmd && cmd.linkedWithPatrimonyAsHomeOwnerAssociation),
                    patrimonyUid: lot && lot.patrimony && lot.patrimony.uid,
                },
            }))
        }
    }

    componentWillMount() {
        this.componentStart(this.props)
    }

    componentWillReceiveProps(props, newState) {
        this.componentStart(props, props.patrimony != this.props.patrimony || props.lot != this.props.lot)
    }

    _end = () => {
        const {dispatch, onHide, patrimony, lot} = this.props
        dispatch(resetReferenceUserCmd())

        setTimeout(() => {
            patrimony && dispatch(loadPatrimony())
            lot && dispatch(loadLot())
            dispatch(loadContactStream())
        }, 1000)

        onHide()
    }

    _sendLink = () => {
        const {dispatch, patrimony, lot} = this.props
        const patrimonyUid = patrimony ? patrimony.uid : lot.patrimony.uid

        return dispatch(sendLinkPatrimonyContactWithUser(patrimonyUid)).then(this._end)
    }

    _patrimonyContactCreated = () => {
        const {dispatch, updateUserCmd} = this.props
        const {shouldCreateUser} = updateUserCmd

        if (shouldCreateUser) {
            return dispatch(sendReferenceUserCmd())
                .then((referenceCmdUserSent) => {
                    const {status, errorType} = referenceCmdUserSent
                    if (status === 400) {
                        if (errorType !== 'UserAlreadyExist') {
                            return errorStatus(errorType)
                        }
                    } else if (status === 201) {
                        return this._sendLink()
                    }
                })
        } else {
            return this._end()
        }
    }

    _sendCmd = () => {
        const {dispatch} = this.props

        return dispatch(sendReferencePatrimonyContactCmd())
            .then(this._patrimonyContactCreated)
    }

    _needMail = () => {
        const {form} = this.props
        const {shouldCreateUser} = this.state

        let mailsList = mediumField(form.contacts(), 'Mail').value
        if (shouldCreateUser) {
            return mailsList.length === 0 || mailsList[0].length === 0
        }
        return false
    }

    _changeUserCreation = () => {
        const {dispatch, cmd} = this.props
        const {shouldCreateUser} = cmd
        dispatch(sendShouldCreateUser(!shouldCreateUser))
    }

    _displayCheckboxCreateUser = () =>{
        const {_links, cmd} = this.props
        const {shouldCreateUser} = cmd ? cmd : {shouldCreateUser: false}
        return _links.find(linkFinder('ReferencePatrimonyUser'))
            && (<div onClick={this._changeUserCreation} className={style.userCreation}>
                <input type="checkbox" checked={shouldCreateUser} /> {i18n.patrimonyUser.createInSameTime}
            </div>)
    }


    _overrideMediumFieldForUserCreation = (previous) => {
        const {needMail} = this._needMail()
        const overridden = {...previous}

        if (needMail) {
            overridden.bsStyle = 'error'
        }
        return overridden
    }

    _renderContactForm = () => {
        const {dispatch, form, cmd, patrimony, lot, onHide, editButton, editContainer, popoverToOpen, ...others} = this.props
        const {linkTypes} = this.state
        const popover = <Popover
            title={i18n.newContact}
            {...others}>
            <div className={style.defaultContent}>
                {linkTypes.length > 1 && (
                    <div className={style.linkType}>
                        <Row>
                            <Col xsHidden sm={3}>
                                <h5>type</h5>
                            </Col>
                            <Col sm={9}>
                                <ButtonToggle
                                    {...linkTypeField(form.linkedWithEntities.linkType())}>
                                    <ul className={style.container}>
                                        {linkTypes.map((linkType, index) => (
                                            <li
                                                key={index}>
                                                <Button
                                                    bsStyle='link'
                                                    value={linkType}>
                                                    <Icon
                                                        icon={(patrimony && this._getIcon(linkType)) || (lot && linkType.slice(11))}
                                                        size='md'/>
                                                    <span>{extract(i18n.patrimonyContactLinkTypeEnum, linkType)}</span>
                                                </Button>
                                            </li>
                                        ))}
                                    </ul>
                                </ButtonToggle>
                                {this._displayCheckboxCreateUser()}
                            </Col>
                        </Row>
                    </div>
                )}
                <form className='form-horizontal'>
                    {form.linkedWithEntities.position && (
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='select'
                            name='position'
                            label={i18n.homeOwnerAssociationPosition}
                            {...form.linkedWithEntities.position()}>
                            <option value=''></option>
                            {HOME_OWNER_ASSOCIATION_POSITIONS.map((position, index) => (
                                <option
                                    key={index}
                                    value={position}>
                                    {extract(i18n.homeOwnerAssociationPositionEnum, position)}
                                </option>
                            ))}
                        </Input>
                    )}
                    {form.linkedWithPatrimonyAsHomeOwnerAssociation && (
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='select'
                            name='position'
                            label={i18n.homeOwnerAssociation}
                            {...linkedWithField(lot, form.linkedWithPatrimonyAsHomeOwnerAssociation())}>
                            <option value=''></option>
                            {HOME_OWNER_ASSOCIATION_POSITIONS.map((position, index) => (
                                <option
                                    key={index}
                                    value={position}>
                                    {extract(i18n.homeOwnerAssociationPositionEnum, position)}
                                </option>
                            ))}
                        </Input>
                    )}
                    {form.linkedWithEntities.linkedAs && (
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='select'
                            name='position'
                            label={i18n.homeOwnerAssociationPosition}
                            {...form.linkedWithEntities.linkedAs()}>
                            <option value=''></option>
                            {NON_REFERENCED_LOT_POSITIONS.map((position, index) => (
                                <option
                                    key={index}
                                    value={position}>
                                    {extract(i18n.patrimonyContactLinkTypeEnum.linkToNonReferencedLot, position)}
                                </option>
                            ))}
                        </Input>
                    )}
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='company'
                        label={i18n.company}
                        {...form.namez.company()} />
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='select'
                        name='gender'
                        label={i18n.gender}
                        {...form.namez.gender()}>
                        <option value=''></option>
                        <option value='Male'>{i18n.genderEnum.male}</option>
                        <option value='Female'>{i18n.genderEnum.female}</option>
                    </Input>
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='firstName'
                        label={requiredLabel(i18n.firstName)}
                        {...form.namez.firstName()} />
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='lastName'
                        label={requiredLabel(i18n.lastName)}
                        {...form.namez.lastName()} />
                </form>
                <h5>
                    <span>{i18n.contactDetails} <i>*</i></span>
                    <small>{i18n.contactDetailsText}</small>
                </h5>
                <form className='form-horizontal'>
                    <MultiInput
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='phone'
                        label={i18n.phone}
                        {...phonesField(mediumField(form.contacts(), 'Phone'))} />
                    <MultiInput
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='email'
                        label={i18n.email}
                        {...this._overrideMediumFieldForUserCreation(mediumField(form.contacts(), 'Mail'))} />
                    <MultiInput
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='fax'
                        label={i18n.fax}
                        {...phonesField(mediumField(form.contacts(), 'Fax'))} />
                </form>
                <h5>{i18n.address}</h5>
                <form>
                    <Row>
                        <Col xs={4}>
                            <Input
                                type='text'
                                name='digicode'
                                placeholder={i18n.addressDigicode}
                                {...form.address.digicode()} />
                        </Col>
                        <Col xs={4}>
                            <Input
                                type='text'
                                name='staircase'
                                placeholder={i18n.addressStaircase}
                                {...form.address.staircase()} />
                        </Col>
                        <Col xs={4}>
                            <Input
                                type='text'
                                name='floor'
                                placeholder={i18n.addressFloor}
                                {...form.address.floor()} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <TypeaheadInput
                                ref='typeahead'
                                source={autocompleteMatcher}
                                display={displayPrediction}
                                highlight={highlightPrediction}
                                placeholder={i18n.addAddress}
                                buttonAfter={addressTypeaheadButton(cmd, form)}
                                {...addressField(form.address())} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={4}>
                            <Input disabled
                                   type='text'
                                   name='number'
                                   placeholder={i18n.addressNumber}
                                   {...form.address.number()} />
                        </Col>
                        <Col xs={8}>
                            <Input disabled
                                   type='text'
                                   name='street'
                                   placeholder={i18n.addressStreet}
                                   {...form.address.street()} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={4}>
                            <Input disabled
                                   type='text'
                                   name='zipCode'
                                   placeholder={i18n.addressZipCode}
                                   {...form.address.zipCode()} />
                        </Col>
                        <Col xs={8}>
                            <Input disabled
                                   type='text'
                                   name='city'
                                   placeholder={i18n.addressCity}
                                   {...form.address.city()} />
                        </Col>
                    </Row>
                </form>
                <ButtonToolbar>
                    <LoaderButton
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid() || this._needMail()})}
                        onClick={() => form.validate() && !this._needMail() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.save}
                    </LoaderButton>
                    <Button
                        bsSize='large'
                        onClick={onHide}>
                        {i18n.cancel}
                    </Button>
                </ButtonToolbar>
            </div>
        </Popover>
        const overlay = <Overlay rootClose
                                 target={() => findDOMNode(editButton)}
                                 placement='bottom'
                                 show={popoverToOpen === 'ReferencePatrimonyContactPopover'}
                                 container={editContainer}
                                 onHide={onHide}>
                                {popover}
                        </Overlay>

        return (overlay)
    }

    _renderUserAlreadyExists = (show) => {
        const {onHide} = this.props
        return (
            <Modal show={show}>
                <Modal.Body>
                    <div className={style.defaultContent}>
                    <div>{i18n.patrimonyUser.linkToUserError}</div>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            onClick={this._sendLink}>
                            {i18n.patrimonyUser.linkToUser}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                    </div>
                </Modal.Body>
            </Modal>)
    }

    _getIcon = (linkType) => {
        switch (linkType) {
            case 'LinkToPatrimonyAsCareTaker':
                return 'CareTaker'
            case 'LinkToPatrimonyAsHomeOwnerAssociation':
                return 'HomeOwnerAssociation'
            case 'LinkToNonReferencedLot':
                return 'HomeOwnerAssociation'
        }
    }

    render() {
        const {updateUserCmd} = this.props
        const {shouldCreateUser, status, errorType} = updateUserCmd || {}
        const show = shouldCreateUser && status === 400 && errorType === 'UserAlreadyExist'
        return show ? this._renderUserAlreadyExists(show) : this._renderContactForm()
    }
}

ReferencePatrimonyContactPopover = connectForm({
    validator: createValidator(),
    target: 'cmd',
    schema: ReferencePatrimonyContactCmd.selectSchema,
    action: REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED
})(ReferencePatrimonyContactPopover)

ReferencePatrimonyContactPopover = connect((state) => ({
    cmd: state.patrimony.referencePatrimonyContactCmd,
    updateUserCmd: state.patrimony.updateUserCmd,
    _links: state.patrimony.contact._links
}))(ReferencePatrimonyContactPopover)

export default ReferencePatrimonyContactPopover


// WEBPACK FOOTER //
// ./lib/patrimony/components/ReferencePatrimonyContactPopover.js